import Icon from '../components/Icon.vue'

Icon.register({
  'car-battery': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M480 128c17.7 0 32 14.3 32 32v256c0 17.7-14.3 32-32 32h-448c-17.7 0-32-14.3-32-32v-256c0-17.7 14.3-32 32-32h32v-48c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16v48h128v-48c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16v48h32zM192 264v-16c0-4.4-3.6-8-8-8h-112c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h112c4.4 0 8-3.6 8-8zM448 264v-16c0-4.4-3.6-8-8-8h-40v-40c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v40h-40c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h40v40c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-40h40c4.4 0 8-3.6 8-8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/car-battery.js
// module id = 1146
// module chunks = 0